module.exports = __webpack_public_path__ + "c3d26ba496877564d0bf23ab9e8d683a.svg";